<div style="position:fixed; top: 0; z-index:9999999; width:100%;">
    <div class="container" style="text-align: center;">
        <div class="session-notice label label-warning ">
            View as {{user.email}}, please do not modify anything
        </div>
    </div>
</div>
